import React from 'react';
import { Grid, Paper } from '@material-ui/core';

// styles
import useStyles from './styles';

//components
import { Typography } from '../../components/Wrappers';

// logo
import logo from '../../images/logo-large.jpg';

const TreatmentPlan = () => {
    const classes = useStyles();

    return (
        <Grid container className={classes.container}>
            <Paper classes={{ root: classes.paperRoot }}>
                <div className={classes.logotype}>
                    <img className={classes.logotypeIcon} src={logo} alt="logo" />
                </div>
                <Typography variant="h5" color="primary" className={classes.textRow}>
                    Treatment plans are now managed directly through SmileAcademy.
                </Typography>
                <Typography variant="body1" className={classes.textRow}>
                    Please contact your SmileAcademy representative for access to your treatment plans.
                </Typography>
            </Paper>
        </Grid>
    );
};

export default TreatmentPlan;
